export default __webpack_public_path__ + "img/icon-flag-cn.asset.old.87458561.jpg";